import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {VehicleCategory} from '../models/vehicle-category.model';
import {VehicleCategoryResponse} from '../models/vehicle-category-response.model';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class VehicleCategoryResponseMapper extends Mapper<VehicleCategoryResponse, VehicleCategory> {

  override map(source: VehicleCategoryResponse): VehicleCategory {
    return new VehicleCategory(
      source.availableItemCategory,
      source.name);
  }
}
